import React, { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux'
import { signOut, getSeasons, cambiaHotel, getHoteles } from '../../actions'
import SubHeader from "./SubHeader";
import Logo from "./Logo";
import { RootState } from '../../reducers/index'
import MenuItem from "./MenuItem";

interface Unidad {
	nombre: string;
	id: number;
	color: string;
	logo: string;
}

interface IMenuItem {
	name: string;
	icon: React.ReactNode;
	options: IMenuOption[];
}

interface IMenuOption {
	name: string;
	dest: string;
}

const Header = (props) => {
	const dispatch = useDispatch()
	const { conta, usuario, enquiries } = useSelector((state: RootState) => state)
	useEffect(() => {
		dispatch(getSeasons())
	}, [])

	useEffect(() => {
		if (enquiries.season_today) {
			//console.log(enquiries.season_today)
		}
		if (conta.hoteles.length < 1) dispatch(getHoteles())
	}, [conta.hoteles.length, enquiries.season_today, dispatch])

	const handleHotelChange = async (e) => {
		dispatch(cambiaHotel(e.target.value))
	}

	function parseaMenu(data): IMenuItem[] {
		const menu: IMenuItem[] = []
		const menu_indexids: number[] = []
		for (let opcion of data) {
			if (!menu_indexids.includes(opcion.parent_id)) {
				menu.push({
					name: opcion.parent_nombre,
					icon: <div style={{ display: "flex", width: "40px", justifyContent: 'center' }}><img src={`${process.env.PUBLIC_URL}/imgs/${/*'resto.svg'*/opcion.parent_icon}`} alt={`${opcion.parent_nombre}_BOT`} /></div>,
					options: []
				})
				menu_indexids.push(opcion.parent_id)
			}
			menu[menu_indexids.indexOf(opcion.parent_id)].options.push({
				name: opcion.sub_nombre,
				dest: opcion.sub_dest
			})
		}
		return menu
	}

	return usuario.user && usuario.unidades && <header className=" fixed-top" style={{ height: "90px" }}>
		<nav className="navbar navbar-expand-xl navbar-light menu_principal" style={{ height: "70px", backgroundColor: "#fff" }}>

			{usuario.unidades[usuario.id_hotel_def] &&
				<Logo img={process.env.PUBLIC_URL + "/imgs/" + usuario.unidades[usuario.id_hotel_def].logo} />
			}

			{usuario.user.tipo < 6 &&
				<>
					<a className="ms-2" target="_blank" href="https://www.surfandyogacostarica.com">
						<img src={process.env.PUBLIC_URL + "/imgs/blv.png"} className="d-inline-block align-top" alt="" />
					</a>
					<a className="ms-2" target="_blank" href="https://sirvoy.com/">
						<img src={process.env.PUBLIC_URL + "/imgs/sirvoy.png"} className="d-inline-block align-top" alt="" />
					</a>
				</>
			}

			<button className="navbar-toggler"
				type="button"
				data-bs-toggle="collapse"
				data-bs-target="#navbarSupportedContent"
				aria-controls="navbarSupportedContent"
				aria-expanded="false"
				aria-label="Toggle navigation">
				<span className="navbar-toggler-icon"></span>
			</button>

			<div
				className="collapse navbar-collapse justify-content-end" id="navbarSupportedContent"
				style={{ justifyContent: "flex-end", textAlign: "end" }}
			>
				<ul className="navbar-nav align-items-center" style={{ backgroundColor: "#fff" }}>

					{usuario.menu && usuario.menu.length > 0 && parseaMenu(usuario.menu).map((opt, i) => <MenuItem {...opt} key={i} />)}

					<li className="nav-item dropdown  logout-button">
						<a className="nav-link   naranja monse text-center" onClick={() => dispatch(signOut())} title="LOGOUT" style={{ cursor: "pointer" }}>
							<div style={{ height: "52px" }} className="text-center d-flex flex-column justify-content-end align-items-center">
								<img src={process.env.PUBLIC_URL + "/imgs/logout.png"} />
								<h6 style={{ fontSize: "13px", marginTop: "5px", marginBottom: "0px", fontWeight: "500" }}>LOGOUT</h6>
							</div>
						</a>
					</li>


					{(enquiries.season_today && enquiries.season_today && enquiries.season_today.season) &&
						<li className="nav-item dropdown p-2 text-center" style={{ backgroundColor: enquiries.season_today.color, color: "#fff" }}>
							{enquiries.season_today.season.replace("Season", "").toUpperCase()}
						</li>
					}

					{Object.keys(usuario.unidades).length > 1 ?
						<li className="nav-item dropdown  naranja p-2 ">
							<select
								className="form-select form-select-sm w-100"
								onChange={handleHotelChange}
								value={String(usuario.id_hotel_def)}
							>
								{Object.entries(usuario.unidades as Record<string, Unidad>).map(([id, unidad]) => <option key={'un_' + id} value={id}>{unidad.nombre}</option>)}
							</select>
						</li> : <></>
					}
				</ul>
			</div>
		</nav>

		{usuario.user && usuario.user.hasOwnProperty("id") && usuario.unidades[usuario.id_hotel_def] && <SubHeader usuario={usuario} color={usuario.unidades[usuario.id_hotel_def].color} />}

	</header>
}

export default Header
